import "./Feature.scss";
import Feature1 from "../../assets/images/oca-page/oca-feature-1.svg";
import Feature2 from "../../assets/images/oca-page/oca-feature-2.png";
import Feature3 from "../../assets/images/oca-page/oca-feature-3.svg";

const Intro = ({}) => {
  return (
    <div className="feature-paper-root">
      <div className="container">
        <span className="feature-title">
          Built for Learners, Educators, and Innovators
        </span>
        <span className="feature-subtitle mt-20">
          Your learning journey deserves recognition that matters. With OC
          Achievements, every step of your growth is captured through secure,
          meaningful digital credentials that showcase your real skills and
          experience.
        </span>
        <div className="grid-container">
          <div className={"flex flex-col mt-30"}>
            <div className={"image-box-root"}>
              <img src={Feature1} alt={""} width={300} height={250} />
            </div>
            <span className="feature-card-title">For Learners</span>
            <span className="feature-card-subtitle">
              Your achievements tell your story. Whether you're completing top
              Web3 courses, joining exclusive internship programs, or
              participating in expert-led mentoring, your OC-ID connects you to
              opportunities across the ecosystem. Each credential is securely
              verified on EDU Chain, creating a trusted record of your journey.
            </span>
          </div>
          <div className={"flex flex-col mt-30"}>
            <div className={"image-box-root"}>
              <img src={Feature2} alt={""} width={300} height={250} />
            </div>
            <span className="feature-card-title">For Education Partners</span>
            <span className="feature-card-subtitle">
              Join our thriving community of 60+ education providers shaping the
              future of Web3 learning. Through the OC-X accelerator, you'll
              access grants from 35-100k USD, expert mentorship, and a network
              of fellow innovators. Our simple integration lets you focus on
              what matters most - creating exceptional learning experiences.
            </span>
          </div>
          <div className={"flex flex-col mt-30"}>
            <div className={"image-box-root"}>
              <img src={Feature3} alt={""} width={300} height={250} />
            </div>
            <span className="feature-card-title">For Developers</span>
            <span className="feature-card-subtitle">
              Technical teams can access our comprehensive developer
              documentation at EDU Chain devdocs. Our devdocs provide everything
              needed for integration - from initial API setup to advanced
              features like achievement minting and verification protocols. Find
              detailed guides, code examples, and EDU Chain interaction
              specifications to seamlessly implement OC Achievements into your
              platform.
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Intro;
